import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const TeamworkIcon = createIcon({
  displayName: 'TeamworkIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.225,6.452v0c0,-1.532 1.242,-2.775 2.775,-2.775v0c1.532,0 2.775,1.242 2.775,2.775v0c0,1.532 -1.242,2.775 -2.775,2.775v0c-1.533,-0.002 -2.775,-1.244 -2.775,-2.775Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M2.5,17.548v0c0,-1.532 1.242,-2.775 2.775,-2.775v0c1.532,0 2.775,1.242 2.775,2.775v0c-0.001,1.532 -1.242,2.775 -2.775,2.775v0c-1.533,3.55271e-15 -2.775,-1.242 -2.775,-2.775Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.951,17.548v0c0,-1.532 1.242,-2.775 2.775,-2.775v0c1.532,0 2.775,1.242 2.775,2.775v0c0,1.532 -1.242,2.775 -2.775,2.775v0c-1.534,3.55271e-15 -2.775,-1.242 -2.775,-2.775Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.49,11.92l-2.01,3.14"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.5,8.78l2.01,3.14"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.95,17.55h-3.95"
        ></path>
      </g>
    </>
  ),
})

const Teamwork: FC<IconProps> = (props) => {
  return <CustomIcon as={TeamworkIcon} {...props} />
}

export default memo(Teamwork)
